import { Inline, LinkButton, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import { CABIN_UPGRADE } from '../../products';
import { useDynamicIcon } from '../../common/utils/dynamic-icons/useDynamicIcon';
import { DYNAMIC_ICON } from '../../common/utils/dynamic-icons/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  display: grid;
  grid-column-start: 2;
  justify-content: end;
`;
const iconStyles = content => css`
  content: ${content};
  grid-row-start: 1;
  height: 20px;
`;
const linkButtonStyles = css`
  grid-row-start: 1;
`;
const ChangeUpgradeSelection = _ref => {
  let {
    setIsDrawerOpen,
    label
  } = _ref;
  const [icon] = useDynamicIcon(vars.colors.links.default, DYNAMIC_ICON.editIcon);
  return /*#__PURE__*/_jsxs(Inline, {
    className: wrapperStyles,
    spacing: 0,
    children: [/*#__PURE__*/_jsx(DangerousHtmlContent, {
      className: iconStyles(icon)
    }), /*#__PURE__*/_jsx(LinkButton, {
      className: linkButtonStyles,
      "data-testid": `${CABIN_UPGRADE.name}-change-upgrade-link-button`,
      onClick: () => setIsDrawerOpen(true),
      children: label
    })]
  });
};
export default ChangeUpgradeSelection;
//# sourceMappingURL=ChangeUpgradeSelection.js.map